import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { GetcustomerLogs } from "../../../store/async-actions/digitalmarketing/customer";
import { BsPlusLg, BsThreeDots } from "react-icons/bs";
import AddLogs from "./AddLogs";
import { VscChromeClose } from "react-icons/vsc";
import { CallStatus, LogMediums } from "./Utils/SelectInputLabel";

function CustomerLogs(props) {
  const { callBackforErrorMessage, openSnackBar } = props;
  const view = window.location.pathname.split("/")[2] ==="customerview" ;

  // console.log(view);
  
  const [isadd, setadd] = useState<boolean>(false);
  const Logs = useSelector((state: any) => state.customer);
  const dispatch = useDispatch<any>();
  useEffect(() => {
    dispatch(GetcustomerLogs(null));
  }, [dispatch]);
  const logs = [...Logs.customerLogs].reverse();
  const renderMeidum = (medium) => {
    let data = LogMediums.find((item) => item.label?.toLowerCase() == medium?.toLowerCase())
    if (data) {
      return <span>{data.icon} {data.label}</span>
    }
    else {
      return <span>{medium}</span>
    }
  }

  const renderStatus = (status) => {
    let data = CallStatus.find((item) => item.label?.toLowerCase() == status?.toLowerCase())
    if (data) {
      return <span>{data.label}</span>
    }
    else {
      return <span>{status}</span>
    }
  }
  return (
    <>
      <div className="mb-2">
        <span className="title">Logs</span>
        {!view &&(  <button
          id="btn-blue"
          onClick={() => setadd(!isadd)}
          disabled={view}
        >
          {isadd ? <VscChromeClose /> : <BsPlusLg />}
        </button>)}
      </div>
      <TableContainer component={Paper}>
        <div className="table-y-responsive">
          <Table sx={{ minWidth: 500 }} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell align="left" width={125}>Medium</TableCell>
                <TableCell align="left">Status</TableCell>
                <TableCell align="left" width={170}>Comments</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {isadd ? <AddLogs setadd={setadd} view={view} openSnackBar={openSnackBar} callBackforErrorMessage={callBackforErrorMessage} /> : ""}
              {logs.map((row, i) => (
                <TableRow
                  key={i}
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  {/* <TableCell component="th" scope="row">
                    <span>{new Date(row.createdAt).toLocaleDateString('en-GB', {
                      day: 'numeric', month: 'short', year: 'numeric'
                    })}</span>
                    <br></br>
                    <small>{new Date(row.createdAt).toLocaleTimeString([], { hour12: true })}</small>
                  </TableCell> */}
                  <TableCell align="left">
                    {renderMeidum(row.medium)}
                    {/* {LogMediums.map((a, i) => a.label.toLowerCase() === row.medium.toLowerCase() ? (<span key={i}>{a.icon} {a.label}</span>) : (""))} */}
                  </TableCell>
                  <TableCell align="left">
                    {renderStatus(row.status)}
                  </TableCell>
                  <TableCell align="left">{row.comments}</TableCell>
                  {/* <TableCell align="center"></TableCell> */}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      </TableContainer>
    </>
  );
}

export default React.memo(CustomerLogs);
